import { fetchAuthSession } from "@aws-amplify/auth";
import { useEffect, useState } from "react";

export function useIsLoggedInUser() {
    const [isLoggedInUser, setIsLoggedInUser] = useState<boolean>(false);
    const [isFetchingAuth, setisFetchingAuth] = useState<boolean>(true);

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const session = await fetchAuthSession({forceRefresh: true});
                if (session.tokens)
                    setIsLoggedInUser(() => true);
            } catch (error) {
                console.error("Error fetching user:", error);
            }
            setisFetchingAuth(()=> false);
        };
        fetchUser();
    }, []);

    return [ isLoggedInUser, isFetchingAuth ];
}